import { BaseModel } from '../../_base/crud';
import {Address} from './address.model';



export class Project extends BaseModel {
  uuid: string;
  title: string;
  designer: string;
  approvedBy: string;
  customerName: string;
  customerId: string;
  referenceId: string;
  drawingId: string;
  address: Address;
  telephone: string;
  mobile: string;
  formType: string;
  earthingSystem: string;
  iecStandard:string;
  ipRating: string;
  orginDate: string;
  voltage:string;
  busbarLocation: string;
  cabledirection: string;
  shortCircuitTime: string;
  version: string;
  colour: string;
  innerProfileColour: string;
  discount: number;
  frightCharges: number;
  shipmentMode: string;
  portName: string;
  panelname: string;
  specialNote: string;
  salePersonCode : string;
  userId : string;
  createdAt?: Date;
  updatedAt?: Date;
  deleted: boolean; // Added deleted field
  deletedBy: string; // Added deletedBy field
  deletedAt: Date;
  copperSize: string;

  depthoption: {component: number, busbar: number, total: number};

  clear(): void {
    this._id = undefined;
    this.title = '';
    this.designer = '';
    this.approvedBy = '';
    this.customerName = '';
    this.customerId = undefined;
    this.referenceId = undefined;
    this.drawingId = undefined;
    this.address = new Address();
    this.address.clear();
    this.telephone = '';
    this.mobile = '';
    this.formType = ''; 
    this.earthingSystem = '';
    this.iecStandard = '';
    this.ipRating = '';
    this.orginDate = '';
    this.voltage = '';
    this.busbarLocation = '';
    this.cabledirection = '';
    this.shortCircuitTime = '';
    this.version = '';
    this.colour = '';
    this.innerProfileColour = '';
    this.discount = undefined;
    this.frightCharges = undefined;
    this.shipmentMode = undefined;
    this.portName = undefined;
    this.specialNote=undefined;
    this.panelname = '';
    this.depthoption = {component: undefined, busbar: undefined, total: undefined};
    this.salePersonCode = '';
    this.userId = '';
    this.createdAt = undefined;
    this.updatedAt = undefined;
    this.copperSize = '',
    this.deleted = false; // Initialize deleted to false
    this.deletedBy = ''; // Initialize deletedBy as an empty string
    this.deletedAt = null;
  }
}
